import { createFileRoute } from '@tanstack/react-router';
import { MemberObserverPage } from '@/pages/chain/MemberObserverPage';

export const Route = createFileRoute('/_authenticated/_app/chain/companies/$memberId/')({
	component: MemberObserverPage,
});
